interface LogoProps {
  style?: React.CSSProperties
  height: string
  alt: string
}

const Logo = ({ style, height, alt }: LogoProps) => {
  return (
        <img src="/static/images/logo/logo.png" alt={alt} height={height} style={style} />
  )
}

export default Logo
